import React__default, { useState } from 'react';
import { DownOutlined, UpOutlined } from '@teko/ds-icon';
import { Flex } from '../Flex/Flex.es.js';
import styled from '@emotion/styled';

function Collapse({
  items = [],
  render,
  max = 3,
  showText,
  hideText
}) {
  const [itemToShow, setItemToShow] = useState(max);
  const children = render ? items.slice(0, itemToShow).map((item, index) => render(item, index)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  const showMore = () => setItemToShow(items.length);
  const showLess = () => setItemToShow(max);
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, children), /* @__PURE__ */ React__default.createElement(Flex, {
    justify: "center"
  }, max >= items.length ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null) : itemToShow < items.length ? /* @__PURE__ */ React__default.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showMore
  }, showText, /* @__PURE__ */ React__default.createElement(DownOutlined, {
    size: 14
  })) : /* @__PURE__ */ React__default.createElement(StyledFlexWrapper, {
    align: "center",
    gap: "s4",
    onClick: showLess
  }, hideText, /* @__PURE__ */ React__default.createElement(UpOutlined, {
    size: 14
  }))));
}
const StyledFlexWrapper = styled(Flex)`
  cursor: pointer;
  background-color: unset;
  color: #82869e;
  border: 0px;
  &:focus {
    border: 0px;
    outline: 0px;
  }
`;

export { Collapse };
